import { render, staticRenderFns } from "./VerificationRequired.vue?vue&type=template&id=b67cb798&scoped=true"
import script from "./VerificationRequired.vue?vue&type=script&lang=js"
export * from "./VerificationRequired.vue?vue&type=script&lang=js"
import style0 from "./VerificationRequired.vue?vue&type=style&index=0&id=b67cb798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67cb798",
  null
  
)

export default component.exports